import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { notifications } from '@mantine/notifications';
import { useLocation, matchPath } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateExtraDetails } from '@/data/features/proposal/proposal';
import routes from '@/routes';
import { getRouteById } from '@/helpers/routes';
import { SSE_TYPES } from '../../helpers/enums';

const processSSEData = async (obj) => {
  const {
    t,
    e,
    pathname,
    dispatch,
    clientId,
  } = obj;

  const { type, data } = e;

  const parsedData = JSON.parse(data || '{}');
  const { clientId: eventClientId, clientName } = parsedData;

  const onRoute = !!matchPath({ path: getRouteById(routes.newProposal.id, 'borrower')?.path }, pathname);
  const onRouteWithId = !!matchPath({ path: getRouteById(routes.newProposal.id, 'borrowerWithId')?.path }, pathname);

  if (type === SSE_TYPES.message) {
    if ((onRoute || onRouteWithId) && clientId === eventClientId) {
      dispatch(updateExtraDetails({ isApprovedClient: true }));
    } else {
      notifications.show({
        title: t('global.process.success.title', { clientName }),
        message: t('global.process.success.message'),
        autoClose: false,
      });
    }
  }
};

const SSEHandler = (props) => {
  const { event } = props;

  const { t } = useTranslation();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { clientId } = useSelector((state) => state.proposal.extraDetails);

  useEffect(() => {
    const run = async () => {
      const processObj = {
        t,
        e: event,
        pathname,
        dispatch,
        clientId,
      };

      await processSSEData(processObj);
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  return null;
};

SSEHandler.propTypes = {
  event: PropTypes.object,
  t: PropTypes.func,
};

export default SSEHandler;
